import { render } from "./App.vue?vue&type=template&id=85e6d988"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=85e6d988&lang=scss"

import exportComponent from "/home/afs/ASF/Release/jena/target/checkout/jena-fuseki2/jena-fuseki-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__